export default "__VITE_ASSET__6d3bc29e__"